import { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import RatingManagementComp from "../../components/RatingManagementComp";
import { AppContext } from "../../contexts/AppContext";

const RatingManagement: React.FC = () => {
  const { findAndSetStore } = useContext(AppContext);
  const { storeId } = useParams<{ storeId: string }>();
  useEffect(() => {
    if (!storeId) return;
    findAndSetStore(storeId);
  }, [storeId]);

  return <RatingManagementComp />;
};

export default RatingManagement;
